export const AGE_RESTRICTION_EVENTS = {
  view_screen: "view_screen",
  select_checkbox: "select_checkbox",
  select_button: "select_button",
};
